import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as TaskConfigurationIcon } from '@/assets/icons/task.svg';
import { isAdmin } from '@/utils/Util';
const Configuration = () => {
	const navigate = useNavigate();
	return (
		<>
			<div className="top-header bg-white pb-2">
				<div className="page-title-area">
					<h1 className="semibold-16">CONFIGURATION</h1>
				</div>
			</div>
			<div className="body-content pt-3">
				<div className="configuration-section onfiguration-main-page">
					<div className="configuaration-wise-single">
						<h4 className="title gray_dark_01 weight-700 regular-16 mb-3">STYLE CATEGORY WISE</h4>
						<div className="measurement-items">
							<div
								className="measuremen-single d-flex justify-content-between align-items-center align-self-center cursor-pointer"
								onClick={() => navigate('/configuration/measurement-template')}
							>
								<div className=" d-flex justify-content-start ">
									<div className="dress-img measurement-img">
										<img
											src={`${process.env.PUBLIC_URL}/icons/pom/ruler.svg`}
											alt="tee"
										/>
									</div>
									<div className="title-subtitle d-flex justify-content-center flex-column align-self-center">
										<p className="semibold-14 weight-500 gray_dark_01">
											Measurement Template
										</p>
									</div>
								</div>
							</div>
							{isAdmin() && (
								<div
									className="measuremen-single d-flex justify-content-between align-items-center align-self-center cursor-pointer"
									onClick={() => navigate('/configuration/task?tab=TASK')}
								>
									<div className=" d-flex justify-content-start ">
										<div className="dress-img measurement-img">
											<TaskConfigurationIcon />
										</div>
										<div className="title-subtitle d-flex justify-content-center flex-column align-self-center">
											<p className="semibold-14 weight-500 gray_dark_01">
												Task configuration
											</p>
										</div>
									</div>
								</div>
							)}
						</div>
					</div>
					<div className="configuaration-wise-single ">
						<h4 className="configuaration-title gray_dark_01 weight-700 regular-16 mb-3">
							INDIVIDUAL ITEM WISE
						</h4>

						<div className="measurement-items">
							<div
								className="measuremen-single d-flex justify-content-between align-items-center align-self-center cursor-pointer"
								onClick={() => navigate('/configuration/pom-list')}
							>
								<div className=" d-flex justify-content-start ">
									<div className="dress-img measurement-img">
										<img
											src={`${process.env.PUBLIC_URL}/icons/pom/t-shirt.svg`}
											alt="tee"
										/>
									</div>
									<div className="title-subtitle d-flex justify-content-center flex-column align-self-center">
										<p className="regular-14 weight-500 gray_dark_01">POM</p>
									</div>
								</div>
							</div>
						</div>

						<div className="measurement-items">
							<div
								className="measuremen-single d-flex justify-content-between align-items-center align-self-center cursor-pointer"
								onClick={() => {
									navigate('/app/request/dashboard-configuration');
									window.location.reload();
								}}
							>
								<div className=" d-flex justify-content-start ">
									<div className="dress-img measurement-img">
										<img
											src={`${process.env.PUBLIC_URL}/icons/pom/t-shirt.svg`}
											alt="tee"
										/>
									</div>
									<div className="title-subtitle d-flex justify-content-center flex-column align-self-center">
										<p className="regular-14 weight-500 gray_dark_01">
											Material & Design dashboard configuration
										</p>
									</div>
								</div>
							</div>
						</div>

						<div className="measurement-items">
							<div
								className="measuremen-single d-flex justify-content-between align-items-center align-self-center cursor-pointer"
								onClick={() => {
									navigate('/app/request');
									window.location.reload();
								}}
							>
								<div className=" d-flex justify-content-start ">
									<div className="dress-img measurement-img">
										<img
											src={`${process.env.PUBLIC_URL}/icons/pom/t-shirt.svg`}
											alt="tee"
										/>
									</div>
									<div className="title-subtitle d-flex justify-content-center flex-column align-self-center">
										<p className="regular-14 weight-500 gray_dark_01">Request list</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default Configuration;
